import Error from '../../layout/layout/error-page/error.vue'
import Error403 from '../../layout/layout/error-page/403.vue'
import Error404 from '../../layout/layout/error-page/404.vue'
import REMOTE404 from '../../layout/layout/error-page/remote-404.vue'
import Home from '../pages/home/index'
import Login from '../pages/login'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { tag: '/', title: '首页' }
  },
  {
    path: '/remote-404',
    component: REMOTE404
  },
  {
    path: '/error',
    name: 'error',
    component: Error
  },
  {
    path: '/403',
    name: 'error403',
    component: Error403
  },
  {
    path: '*',
    component: Error404
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/layout/router/routes.js